import React from "react";
import PageHero from "../components/PageHero";
import Industries from "../components/Industries";
import GCCFeature from "../components/GCCFeature";
import Stats from "../components/Stats";
import CTABanner from "../components/CTABanner";
import { IMAGES } from "../config/siteConfig";

export default function IndustriesPage() {
  return (
    <>
      <PageHero
        label="Industries"
        title="Specialist talent across"
        highlight="key sectors."
        subtitle="We recruit across the industries that drive the GCC economy — from technology and finance to construction, healthcare, and hospitality."
        image={IMAGES.gcc}
      />
      <Industries />
      <GCCFeature />
      <Stats />
      <CTABanner heading="Hiring in your sector?" highlight="Talk to a specialist." />
    </>
  );
}
